import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import V2App from './v2/App';
import { isV2Path } from './v2/constants/path';
import { Provider } from 'react-redux';
import { Router } from 'react-router';

import * as serviceWorker from './serviceWorker';
import BitkeyPlatformAPI from './utils/bitkey-platform-api';
import Datadog from './monitoring/datadog';
import { bkpPath } from './config/baseConfig';

import { ThemeProvider } from '@material-ui/styles';
import { createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme({
  typography: {
    fontFamily: ['Lato', 'Noto Sans CJK JP'].join(','),
    subtitle1: {
      fontSize: '18px',
      fontWeight: 500
    },
    h1: {
      fontWeight: 'bold'
    },
    body1: {
      fontSize: '14px'
    }
  },
  palette: {
    primary: {
      main: '#03A9F4'
    }
  },
  overrides: {
    MuiPickersDay: {
      daySelected: {
        color: 'white'
      },
      current: {
        color: 'black'
      }
    }
  }
});

const isV2 = isV2Path(window.location.pathname);
// 使う方のストアだけ作る。import するとモジュール評価時に v1 / v2 両方の createStore が走る
const store = isV2 ? require('./v2/store').default : require('./store').default;
const history = require('history').createBrowserHistory();

BitkeyPlatformAPI.init(bkpPath);
Datadog.startMonitoring();

ReactDOM.render(
  <Provider store={store}>
    {isV2 ? (
      <ThemeProvider theme={theme}>
        <V2App />
      </ThemeProvider>
    ) : (
      <Router history={history}>
        <ThemeProvider theme={theme}>
          <App />
        </ThemeProvider>
      </Router>
    )}
  </Provider>,
  document.getElementById('root')
);

serviceWorker.unregister();
